/* eslint-disable handle-callback-err */
/**
 * WebSocket Module
 */
import SockJS from 'sockjs-client';
import Stomp from 'stomp-websocket';
import helper from 'util/helpers';
import eventBus from '../../../EventBus';
import util from '@/util';
import { store } from '@/store/store';
import { getCallAgentId } from '@/util/call';
const baseUrl = process.env.BASE_URL;

const getDefaultState = () => {
  return {
    stompClient: null,
    isConnecting: false,
    isConnected: false,
    subscriptions: []
  };
};
const state = getDefaultState();

const getters = {
  IS_CONNECTED: (state) => {
    return state.isConnected;
  }
};
const mutations = {
  START_CONNECT(state) {
    state.isConnecting = true;
  },
  END_CONNECT(state) {
    state.isConnecting = false;
    state.isConnected = true;
    state.stompClient.connected = true;
    return true;
  },
  FAIL_CONNECT(state) {
    state.isConnecting = false;
    state.isConnected = false;
    if (state.stompClient) {
      state.stompClient.connected = false;
    } else {
      state.stompClient = null;
    }
  },
  subscribe(state, payload) {
    let subscription = helper.findByKey(state.subscriptions, payload.key);
    if (subscription === undefined) {
      subscription = state.stompClient.subscribe(payload.subscribeUrl, (tick) => payload.callback(JSON.parse(tick.body), payload.chatRoom));
      const newSubscription = {
        key: payload.key,
        chatRoomId: payload.chatRoomId,
        subscriptionUrl: payload.subscribeUrl,
        id: subscription.id,
        subscription: subscription
      };
      state.subscriptions.push(newSubscription);
    }
    return subscription.id;
  },
  closeSubscriptionWithPrefix(state, prefix) {
    let filtered = state.subscriptions.filter((e) => e.key.includes(prefix));
    state.subscriptions = state.subscriptions.filter((e) => !e.key.includes(prefix));
    filtered.forEach((releasable) => {
      releasable.subscription.unsubscribe();
    });
  },
  forceCloseConnection(state) {
    if (state.subscriptions.length > 0) {
      console.log('모든 소켓 종료');
      state.subscriptions.forEach((releasable) => {
        releasable.subscription.unsubscribe();
      });
      state.subscriptions = [];
    }
  },
  // 어바웃펫 입력 감지 커스텀
  keyboardTypingSend(state, payload) {
    state.stompClient.send(
      `/api/publish/customer/${payload.userKey}`,
      {},
      JSON.stringify({ changeType: 'KEYBOARD_TYPING_SENSOR', data: { chatRoomId: payload.chatRoomId, typing: payload.typing } })
    );
  },
  agentMappingSend(state) {
    state.stompClient.send(
      `/api/publish/call-agent-mapping`,
      {},
      JSON.stringify({ callAgentId: getCallAgentId(), accountId: util.parseLoginToken().accountId })
    );
  }
};

const actions = {
  async connect({ commit, state, dispatch }) {
    if (state.isConnecting) {
      return false;
    }
    commit('START_CONNECT');
    state.stompClient = Stomp.over(new SockJS(baseUrl + '/api/webSocket', null, { transports: 'websocket', timeout: 1000 }));
    if (process.env.NODE_ENV === 'production') {
      state.stompClient.debug = null;
    }
    state.stompClient.connect(
      {},
      (frame) => {
        if (!store.state.isLoggedIn) {
          dispatch('closeWebSocket');
        } else {
          commit('END_CONNECT');
          eventBus.$emit('socket-connection-success');
          // 콜 상담 데스크 > AI 상담요약 사용하는 경우 agent-mapping 메세지 전송 필요
          // 콜 소켓 연동 이후에 (소켓 연동 전에 정보 조회해서 세팅됨) 콜 상담사 정보 중 callLoginId 있다는 전제하에 그 이후에 메세지 전송하게 함
          if (this.getters.hasCallAISummaryOption) {
            this.commit('agentMappingSend');
          }
        }
        return true;
      },
      (error) => {
        console.log('끈김', error);
        commit('forceCloseConnection');
        commit('FAIL_CONNECT');
        eventBus.$emit('reconnect-start');
      }
    );
  },
  closeWebSocket({ state, commit }) {
    if (!state.stompClient) return;
    if (state.stompClient.ws.readyState !== WebSocket.OPEN) {
      return;
    }
    commit('FAIL_CONNECT');
    state.stompClient.disconnect();
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/webSocket/index.js